export namespace AccountRecantEnum {
  export enum SVC_CODE {
    DI = 'DI',
    NAME_DI = '안드로이드',
    IV = 'IV',
    NAME_IV = '아이폰',
    W = 'W',
    NAME_W = '유선',
    MW = 'MW',
    NAME_MW = '무선',
    GI = 'GI',
    NAME_GI = '기가지니',
    AV = 'AV',
    NAME_AV = '안드로이드TV'
  }
}
